var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusicMuteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.8 -1.499) scale(1.00)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6648 3.57673C16.6648 2.96152 16.1802 2.45836 15.5724 2.50052C14.0497 2.60619 10.8896 2.98572 7.86428 4.3537C7.26968 4.62258 6.91285 5.23798 6.91285 5.89618V8.65411C6.91285 8.65609 6.91288 8.65807 6.91297 8.66008V11.5727C6.70121 11.5227 6.48077 11.4962 6.2545 11.4962C4.64082 11.4962 3.33203 12.8394 3.33203 14.4971C3.33203 16.1549 4.64082 17.498 6.2545 17.498C7.86815 17.498 9.17697 16.1549 9.17697 14.4971C9.17697 14.4531 9.17604 14.4091 9.17422 14.3655C9.17573 14.3566 9.17651 14.3473 9.17651 14.3379V7.95934C11.2373 7.21687 13.0776 6.85568 14.3995 6.68017V9.89643C14.1909 9.84757 13.9739 9.82184 13.7511 9.82184C12.1416 9.82184 10.8369 11.1655 10.8369 12.8228C10.8369 14.4801 12.1416 15.8237 13.7511 15.8237C15.3607 15.8237 16.6654 14.48 16.6654 12.8228C16.6654 12.7752 16.6643 12.7279 16.6622 12.6808C16.6628 12.6751 16.663 12.6694 16.663 12.6635V6.37883C16.6642 6.37102 16.6648 6.36311 16.6648 6.3551V3.57673Z",
    fill: "#8E092E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3037 4.11628C21.7919 3.62816 22.5831 3.62816 23.0713 4.11628C23.5594 4.60443 23.5594 5.39573 23.0713 5.88385L20.5176 8.43751L23.0713 10.9913C23.5594 11.4794 23.5594 12.2708 23.0713 12.7589C22.5831 13.247 21.7919 13.2469 21.3037 12.7589L18.75 10.2051L16.1962 12.7589C15.7081 13.247 14.9169 13.2469 14.4288 12.7589C13.9406 12.2706 13.9406 11.4794 14.4288 10.9913L16.9824 8.43751L14.4288 5.88385C13.9406 5.39569 13.9406 4.60441 14.4288 4.11628C14.9169 3.62816 15.7081 3.62816 16.1962 4.11628L18.75 6.67001L21.3037 4.11628Z",
    fill: "#8E092E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicMuteIcon);
export default __webpack_public_path__ + "static/media/music-mute-icon.e1ee5463fc1127867dd138af22ff05f0.svg";
export { ForwardRef as ReactComponent };